import { FC } from 'react'
import { Typography } from '@mui/material'
import { isMobile } from '$utils'

type LoadedPageLeftTitleProps = {
  text: string
}

const LoadedPageLeftTitle: FC<LoadedPageLeftTitleProps> = ({ text }) => {
  return (
    <Typography
      variant="h1"
      sx={{
        fontSize: '2em',
        fontWeight: '700',
        color: 'var(--title-color)',
        ...(isMobile() && {
          fontSize: '1.5em',
          paddingTop: '8px',
          paddingBottom: '8px',
        }),
      }}
    >
      {text}
    </Typography>
  )
}

export default LoadedPageLeftTitle
